<template>
  <div class="button-sm button-sm-edit" :disabled="disabled">
    <button class="button-sm__btn button-sm-edit__btn" :disabled="disabled">
      <svg class="edit-icon" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.09066 15.4697L3.88296 15.459L3.89599 14.0347L2.45133 14.0219L2.46222 12.8313L3.49852 11.8278L6.12702 14.4663L5.09066 15.4697ZM11.0881 5.19626C11.0875 5.26302 11.0641 5.32958 11.0074 5.38472L4.83478 11.3612C4.77785 11.4163 4.70988 11.438 4.64217 11.4374C4.49543 11.4361 4.39477 11.3351 4.39609 11.1904C4.3967 11.1236 4.42011 11.0571 4.47689 11.0019L10.6495 5.02543C10.7064 4.9703 10.7743 4.94865 10.8421 4.94925C10.9888 4.95055 11.0894 5.05161 11.0881 5.19626ZM10.4982 3.05443L1.02289 12.2287L0.980548 16.8576L5.67586 16.8993L15.1511 7.72506L10.4982 3.05443ZM18.1972 4.19117C18.2007 3.81285 18.0461 3.44425 17.7889 3.17489L15.1604 0.547567C14.8919 0.27811 14.5209 0.119021 14.1371 0.115608C13.7533 0.112196 13.3795 0.264662 13.1174 0.529402L11.227 2.34872L15.88 7.01934L17.7705 5.1889C18.0324 4.93528 18.1938 4.56949 18.1972 4.19117Z"
          fill="currentColor"/>
      </svg>
    </button>
    <p class="button-sm__text button-sm-edit__text" v-if="title">{{ title }}</p>
  </div>
</template>

<script>
export default {
  name: 'app-button-sm-edit',
  props: {
    disabled: Boolean,
    title: String
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button-sm {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  cursor: pointer;
  user-select: none;

  &__btn {
    flex-shrink: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $font_color_alt;
    height: 30px;
    width: 30px;
    border-radius: 3px;
    transition: .3s;
    cursor: pointer;
    user-select: none;
    font-family: $font_main;
  }

  &__text {
    transition: .3s;
    margin-left: 10px;
  }

  &[disabled] {
    color: $color_deactive;
    pointer-events: none;

    .button-sm__btn {
      background: $color_deactive;
      box-shadow: none;
    }
  }
}

.button-sm-edit {
  &__btn {
    background: $button_color;
    box-shadow: 0px 2px 2px #C6523B;
  }

  &:hover {
    .button-sm-edit__btn {
      box-shadow: none;
    }

    .button-sm-edit__text {
      color: #ECA506;
    }
  }

  &:active {
    .button-sm-edit__btn {
      box-shadow: inset 0px 4px 4px #BA5932;
    }
  }
}
</style>
